import { icons } from "lucide-react";
const Lucide = (prop) => {
  var LucideIcon = icons["List"];
  if (icons[prop.icon]) {
    LucideIcon = icons[prop.icon];
  }

  return (
    <LucideIcon color="#ff0000" size={prop.size} className={prop?.className} />
  );
};
export default Lucide;
